import { CustomersSettings } from '../../../types/customers';
import { Customer } from '../../types';
import { CustomerCompany } from './types';

export enum ActionTypes {
    EditCustomerAttributes = '[customer/attributes] EDIT_CUSTOMER_ATTRIBUTES',
    FetchEditCustomerAttributesResponse = '[customer/attributes] FETCH_EDIT_CUSTOMER_ATTRIBUTES_RESPONSE',
    FetchEditCustomerAttributesResponseError = '[customer/attributes] FETCH_EDIT_CUSTOMER_ATTRIBUTES_RESPONSE_ERROR',
    ClearEditCustomerAttributesResponseError = '[customer/attributes] CLEAR_EDIT_CUSTOMER_ATTRIBUTES_RESPONSE_ERROR',
    FetchCustomersSettings = '[customer/attributes] FETCH_SETTINGS',
    FetchCustomersSettingsResponse = '[customer/attributes] FETCH_SETTINGS_RESPONSE',
}

export interface EditCustomerAttributes {
    type: ActionTypes.EditCustomerAttributes;
    payload: {
        accountId: string;
        id: string;
        attributes: any;
    };
}

export interface FetchEditCustomerAttributesResponse {
    type: ActionTypes.FetchEditCustomerAttributesResponse;
    payload: {
        customer: Customer;
    };
    meta: {
        cause: EditCustomerAttributes;
    };
}

export interface FetchEditCustomerAttributesResponseError {
    type: ActionTypes.FetchEditCustomerAttributesResponseError;
    payload: {
        error: any;
    };
    meta: {
        cause: EditCustomerAttributes;
    };
}

export interface FetchCustomersSettings {
    type: ActionTypes.FetchCustomersSettings;
    payload: {
        accountId: string;
    };
}

export interface FetchCustomersSettingsResponse {
    type: ActionTypes.FetchCustomersSettingsResponse;
    payload: {
        settings: CustomersSettings;
    };
    meta: {
        cause: FetchCustomersSettings;
    };
}

export interface ClearEditCustomerAttributesResponseError {
    type: ActionTypes.ClearEditCustomerAttributesResponseError;
    payload: {
    };
}

export function clearError() {
    return {
        type: ActionTypes.ClearEditCustomerAttributesResponseError,
        payload: {},
    };
}

export function fetchCustomersSettings(accountId: string) {
    return {
        type: ActionTypes.FetchCustomersSettings,
        payload: {
            accountId,
        },
    };
}


export function editCustomerAttributes(
    accountId: string,
    id: string,
    attributes: any
): EditCustomerAttributes {
    return {
        type: ActionTypes.EditCustomerAttributes,
        payload: {
            accountId,
            id,
            attributes,
        },
    };
}

export type Actions =
    | EditCustomerAttributes
    | FetchEditCustomerAttributesResponse
    | FetchEditCustomerAttributesResponseError
    | FetchCustomersSettings
    | FetchCustomersSettingsResponse
    | ClearEditCustomerAttributesResponseError;
